module.exports = __webpack_public_path__ + "static/hero_bg-5f04a87c011d7b0a42ccde9b19b7cd38.jpg";